import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {LineTypeDomainModel} from "./line-type.domain-model";

export class LineTypeViewModel extends BaseViewModel {
  domainModel: LineTypeDomainModel;

  get shortName(): String {
    return this.domainModel.shortName;
  }

  get title(): String {
    return this.domainModel.title;
  }

  get internalOptionType(): String {
    return this.domainModel.internalOptionType;
  }
}